export const categoriesBtn = [
	{ id: 1, name: "Portrait", query: "PORTRAIT" },
	{ id: 2, name: "Picture", query: "PICTURE" },
	// { id: 3, name: "Interior", query: "INTERIOR_DESIGN" },
];

export const genderBtn = [
	{ id: 1, name: "man", query: false },
	{ id: 2, name: "woman", query: true },
];

export const previewOptions = [
	{ id: 1, name: "Original" },
	{ id: 2, name: "Result" },
];

export const ONE_GENERATION = 4;

export const styleExamplesData = {
	title: "Photo into painting with a few clicks",
	description: "Look at the examples of images created by our online AI generator to get some inspiration",
	items: [
		{
			id: 0,
			animation: true,
			altName: "Picture with style",
			src: "/remove_back/avatar/1_ex.png",
		},
		{
			id: 1,
			animation: false,
			altName: "Picture with style",
			src: "/remove_back/avatar/2_ex.png",
		},
		{
			id: 2,
			animation: false,
			altName: "Picture with style",
			src: "/remove_back/avatar/3_ex.png",
		},
		{
			id: 3,
			animation: true,
			altName: "Picture with style",
			src: "/remove_back/avatar/4_ex.png",
		},
	],
};

export const mainBlockData = {
	title: "photo_into_painting",
	description: "Create awesome painting from your picture with AI",
	videoUrl: "/photo_into_painting/photo_into_painting.mp4",
	posterUrl: "/photo_into_painting/photo_into_painting.png",
};

export const sketchMainData = {
	title: "page_sketch_h1",
	description: "page_sketch_desc",
	videoUrl: "/avatar_gen/sketch/video.mp4",
	posterUrl: "/avatar_gen/sketch/main_preview.webp",
};

export const sketchRightBlock = {
	title: "page_sketch_header3",
	description: "page_sketch_desc3",
	imageSrc: "/avatar_gen/sketch/block3.jpg",
};

export const sketchLeftBlock1 = {
	title: "page_sketch_header2",
	description: "page_sketch_desc2",
	imageSrc: "/avatar_gen/sketch/block2.jpg",
};

export const sketchLeftBlock2 = {
	title: "page_sketch_header4",
	description: "page_sketch_desc4",
	imageSrc: "/avatar_gen/sketch/block5.jpg",
};
